module.exports = __webpack_public_path__ + "img/hotel-del-sol.5b5f5a8a.jpg";